import type {PropsWithChildren} from 'react';
import React, {useMemo} from 'react';
import type {TypographyTypeMap} from '@mui/material/Typography';
import Typography from '@mui/material/Typography';
import {kindColor} from 'theme';
import type {TextProps} from './types';

export const Text: React.FC<PropsWithChildren<TextProps>> = ({
  variant,
  kind = 'primary',
  mode = 'main',
  sx,
  component = 'p',
  textTransform,
  keepWhitespace,
  children,
  className,
  noWrap,
  onClick,
  'data-cy': dataCy,
  'data-sentry-mask': dataSentryMask,
}) => {
  const resolvedSx = useMemo(
    (): TypographyTypeMap['props']['sx'] =>
      textTransform || keepWhitespace
        ? {
            ...sx,
            whiteSpace: keepWhitespace ? 'pre-wrap' : undefined,
            textTransform,
          }
        : sx,
    [keepWhitespace, sx, textTransform],
  );

  const color = kindColor(kind, mode);

  return (
    <Typography
      data-sentry-mask={dataSentryMask}
      data-cy={dataCy}
      className={className}
      variant={variant}
      color={color}
      component={component}
      noWrap={noWrap}
      onClick={onClick}
      sx={{
        ...resolvedSx,
        color,
      }}>
      {children}
    </Typography>
  );
};
